export function StatusDial({ value, label, tone = "neutral" }: { value: number; label: string; tone?: string }) {
  return (
    <div className={`status-dial tone-${tone}`} title={`${label}: ${value}%`}>
      <svg viewBox="0 0 38 38" aria-hidden="true">
        <circle cx="19" cy="19" r="15.5" />
        <circle cx="19" cy="19" r="15.5" pathLength="100" strokeDasharray={`${value} 100`} />
      </svg>
      <span>{value}</span>
      <small>{label}</small>
    </div>
  );
}
